import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Input, Button, CardBody, Card } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import SelectComponent from '@componentes/select/select.component';
import WebapiCommon from '@common/util/webapi.common';
import IntlMessage from '../../../../helpers/intlMessage';
import {enumFiltroTipo, enumFiltroListUrgente, enumFiltroTipoList} from '@common/util/defaultValues';
import CommonFunctions from '@common/util/functions.common';
import { useIntl } from 'react-intl';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../../helpers';

function Filtro({ filtro, setFiltro, filtrar }) {
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const medicos = useSelector(state => state.commonReducer.medicos);
  const [tiposExame, setTiposExame] = useState([]);
  const [optionsSelect, setOptionsSelect] = useState([]);
  const [medicosFiltro, setMedicosFiltro] = useState([]);
  const intl = useIntl();
  const [periodo, setPeriodo] = useState({ value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` });
	const periodos = obterListagemDePeriodos(intl);

  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  useEffect(() => {
    const periodo = CommonFunctions.getPeriodosSubDays(0);
    const { periodoInicial, periodoFinal } = periodo;

    setFiltro({ periodoInicial, periodoFinal });
    loadItensFiltro();
    setMedicosFiltro([{ label: <IntlMessage id="general.requestsPanel.all" />, value: null }, ...medicos]);
  }, [medicos]);

  const onChangeTipoFiltro = item => {
    setFiltro({ ...filtro, tipo: item.value });

    switch (item.value) {
      case enumFiltroTipo.URGENTE:
        setOptionsSelect(enumFiltroListUrgente);
        break;
      case enumFiltroTipo.TIPO_EXAME:
        setOptionsSelect(tiposExame);
        break;
      default:
        break;
    }
  };

  const loadItensFiltro = async () => {
    try {
      const response = await WebapiCommon.getTiposExame();
      setTiposExame(response);
    } catch (error) { }
  };

  const showInput = tipo => {
    switch (tipo) {
      case enumFiltroTipo.NR_EXAME:
      case enumFiltroTipo.NR_PEDIDO:
      case enumFiltroTipo.NOME_PACIENTE:
      case enumFiltroTipo.OBSERVACAO_LAUDO:
        return true;
      default:
        return false;
    }
  };

	function resetarPeriodo() {
		setPeriodo('');
    setFiltro({ ...filtro, periodoInicial: null, periodoFinal: null });
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setPeriodo(e);
    setFiltro({ ...filtro, periodoInicial: payload.dtinicial, periodoFinal: payload.dtfinal });
	}

	function mudarIntervaloPeriodo(val) {
		let payload = changePeriod(val);

    setFiltro({ ...filtro, periodoInicial: payload.start, periodoFinal: payload.end });
	}

  function eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			filtrar(filtro);
	}

  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={'3'}>
            <SelectComponent
              options={medicosFiltro}
              onChange={event => setFiltro({ ...filtro, medico: event.value })}
              placeholder={translate("general.requestsPanel.doctorResponsible")}
              styles={{ borderColor: 'transparent' }}
              disabled={carregando}
            />
          </Col>

          <Col sm={'2'}>
            <SelectComponent
              options={enumFiltroTipoList}
              onChange={item => onChangeTipoFiltro(item)}
              placeholder={translate("general.requestsPanel.searchType")}
              styles={{ borderColor: 'transparent' }}
              disabled={carregando}
            />
          </Col>
          <Col
            sm={'3'}
            style={{
              display:
                filtro.tipo !== enumFiltroTipo.URGENTE &&
                  filtro.tipo !== enumFiltroTipo.TIPO_EXAME
                  ? 'none'
                  : 'initial'
            }}
          >
            <SelectComponent
              options={optionsSelect}
              placeholder={translate("general.requestsPanel.selectAnOption")}
              onChange={event => setFiltro({ ...filtro, value: event.value })}
              styles={{ borderColor: 'transparent' }}
              disabled={carregando}
            />
          </Col>

          <Col
            sm={'auto'}
            style={{
              padding: 0,
              display:
                filtro.tipo !== enumFiltroTipo.DATA_ENTREGA &&
                  filtro.tipo !== enumFiltroTipo.DATA_SOLICITACAO
                  ? 'none'
                  : 'initial'
            }}
          >
            <Row style={{ marginRight: '15px' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
                <div className="label-data"><IntlMessage id="period.name"/></div>
                <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
                  <SelectComponent
                    isClearable
                    className="filtro-data"
                    noOptionsMessage={() => {
                    return intl.formatMessage({id: "dashboards.reports.noItemsFound"});
                    }}
                    name="form-field-period"
                    placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
                    value={periodo}
                    onChange={(e) => {
                    periodoAlterado(e);
                    e && e.value ? mudarIntervaloPeriodo(e.value) : mudarIntervaloPeriodo('todos');
                    }}
                    options={periodos}
                  />
                </div>

                {periodo && periodo.value === 'outro' && (
                  <React.Fragment>
                    <DebounceInput
                    name="periodoDe"
                    type="date"
                    style={{width: '130px', display: 'block'}}
                    className="filtro-data"
                    value={filtro.periodoInicial}
                    onChange={e => setFiltro({ ...filtro, periodoInicial: e.target.value })}
                    onKeyPress={(e) => eventoOnKeyPressData(e)}
                    />
                    <DebounceInput
                    name="periodoAte"
                    type="date"
                    style={{width: '130px', display: 'block'}}
                    className="filtro-data"
                    value={filtro.periodoFinal}
                    onChange={e => setFiltro({ ...filtro, periodoFinal: e.target.value })}
                    onKeyPress={(e) => eventoOnKeyPressData(e)}
                    />
                  </React.Fragment>
                )}
                {/* <div className='label-data'><IntlMessage id="general.requestsPanel.initial" /></div>
                <DebounceInput
                  debounceTimeout={900}
                  onChange={event =>
                    setFiltro({ ...filtro, periodoInicial: event.target.value })
                  }
                  type='date'
                  value={filtro.periodoInicial}
                  disabled={carregando}
                  max={filtro.periodoFinal}
                />

                <div className='label-data'><IntlMessage id="general.requestsPanel.final" /></div>
                <DebounceInput
                  debounceTimeout={900}
                  onChange={event =>
                    setFiltro({ ...filtro, periodoFinal: event.target.value })
                  }
                  type='date'
                  value={filtro.periodoFinal}
                  min={filtro.periodoInicial}
                  disabled={carregando}
                /> */}
              </div>
            </Row>
          </Col>
          <Col
            sm={'3'}
            style={{
              display: showInput(filtro.tipo) ? 'initial' : 'none'
            }}
          >
            <Input
              style={{
                height: '45px',
                borderRadius: '5px',
                fontSize: '13px'
              }}
              type={'text'}
              onChange={event =>
                setFiltro({ ...filtro, value: event.target.value })
              }
              disabled={carregando}
            />
          </Col>
          <Col sm={1}>
            <Button
              className='btn btn-primary'
              onClick={() => filtrar(filtro)}
              style={{ height: '38px', width: '38px' }}
              disabled={carregando || !filtro.tipo}
            >
              <i className='icons-btn mv-basico-pesquisar'></i>
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default Filtro;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Laudos/Filtro/index.js